/**
 * Web component: Anchor section (anchor-section)
 * -----------------------------------------------------------------------------
 * Section used for anchor linking, can be added on any page.
 * - Component settings: section / limited / web / vanilla
 *
 */
import './anchor-section.scss';

import { vueReady } from '~/core/runners';
import useIndexStore from '~stores/index';

/**
 * Create new <anchor-section> custom element.
 */
class AnchorSection extends HTMLElement {
  data() {
    const indexStore = useIndexStore();

    return {
      scrollElement: this.getAttribute('data-scroll'),
      desktopMargin: this.getAttribute('data-desktop-margin'),
      mobileMargin: this.getAttribute('data-mobile-margin'),
      isMobile: indexStore.screen.mobile,
    };
  }

  constructor() {
    super();
    this.$data = this.data(this);
  }

  /**
   * Lifecycle hook - component is attached to DOM.
   */
  connectedCallback() {
    const urlHash = window.location.hash;
    if (urlHash === '' || urlHash !== this.$data.scrollElement) {
      return;
    }

    // waiting until everything is loaded
    setTimeout(() => {
      const margin =
        Number.parseInt(
          this.$data.isMobile
            ? this.$data.mobileMargin
            : this.$data.desktopMargin,
        ) || 0;

      const header = document.querySelector('.site-header-group');
      const headerHeight = header ? header.clientHeight : 0;

      const target = this.parentElement?.nextElementSibling;
      if (!target) return;

      const offset = headerHeight + margin;
      const scrollTolerance = 20;
      const rect = target.getBoundingClientRect();

      const prefersReduced = window.matchMedia?.(
        '(prefers-reduced-motion: reduce)',
      ).matches;
      const behavior = prefersReduced ? 'auto' : 'smooth';

      if (Math.abs(rect.top - offset) <= scrollTolerance) return;

      const scrollToSection = window.scrollY + rect.top - offset;
      try {
        window.scrollTo({ top: scrollToSection, behavior });
      } catch {
        window.scrollTo(0, scrollToSection);
      }
    }, 1000);
  }
}

/**
 * Define web component on Vue initialisation.
 */
vueReady(() => {
  if (customElements.get('anchor-section')) {
    return;
  }

  customElements.define('anchor-section', AnchorSection);
});
